// Contador global de requisições em voo — alimenta o overlay de carregamento.
// Alimentado pelos interceptors do axios (components/loading/axiosLoading.ts),
// então vale para qualquer chamada do app sem instrumentar tela por tela.
let emVoo = 0
let rotuloAtual: string | null = null
const listeners = new Set<() => void>()

// snapshot precisa ser estável entre renders (useSyncExternalStore compara por
// identidade); por isso guardamos a string montada, não um objeto novo a cada vez.
let estado = '0|'

const atualizaEstado = () => {
  estado = `${emVoo}|${rotuloAtual ?? ''}`
  listeners.forEach((l) => l())
}

export const inicioReq = (rotulo?: string) => {
  emVoo++
  if (rotulo) rotuloAtual = rotulo
  atualizaEstado()
}

export const fimReq = (tinhaRotulo?: boolean) => {
  emVoo = Math.max(0, emVoo - 1)
  if (emVoo === 0 || tinhaRotulo) rotuloAtual = emVoo === 0 ? null : rotuloAtual
  atualizaEstado()
}

export const subscribeLoading = (cb: () => void): (() => void) => {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

export const snapshotLoading = (): string => estado

export const lerEstado = (s: string) => {
  const [n, rotulo] = s.split('|')
  return {emVoo: Number(n), rotulo: rotulo || null}
}

/**
 * Controle do overlay por chamada.
 *
 *   API.listUsers()                          → acende (padrão)
 *   API.listUsers({loading: false})          → não acende
 *   API.exportar({loading: 'Gerando…'})      → acende com rótulo próprio
 *
 * Basta repassar o objeto como config do axios:
 *   axios.get('/user/list', opcoesLoading(opts))
 */
export type OpcoesLoading = {loading?: boolean | string}

export const opcoesLoading = (opts?: OpcoesLoading) =>
  opts?.loading === undefined ? {} : ({__loading: opts.loading} as any)

// Chamadas que NÃO acendem o overlay por padrão: polling de fundo (repetiria a
// cada poucos segundos) e operações longas que travariam a tela por minutos.
// Uma chamada pode sobrescrever isso passando {loading: true}.
const SILENCIOSAS = [
  '/maintenance',
  '/settings/maintenance-status',
  '/support/ticket-details', // chat de suporte: poll de 2s
  '/jobs/', // acompanhamento de exportação
  '/service-level/admin/sync', // sync do Databricks (minutos)
  '/notification', // contador de notificações
]

export const ehSilenciosa = (url?: string): boolean => {
  if (!url) return false
  return SILENCIOSAS.some((p) => url.includes(p))
}
